









































import { Component, Vue, Prop } from "vue-property-decorator";

interface ExportFormat {
  value: string;
  label: string;
  icon: string;
  color: string;
}

@Component({
  name: "ExportButton",
  components: {
    Xbtn: () => import("@/components/buttons/x-btn.vue"),
  },
})
export default class ExportButton extends Vue {
  @Prop({ required: true }) data!: any[];
  @Prop({ default: "export" }) filename!: string;
  @Prop({ default: () => ["csv", "json"] }) formats!: string[];
  @Prop({ default: "Exportar" }) buttonText!: string;
  @Prop({ default: "primary" }) color!: string;
  @Prop({ default: false, type: Boolean }) outlined!: boolean;
  @Prop({ default: false, type: Boolean }) text!: boolean;
  @Prop({ default: false, type: Boolean }) icon!: boolean;
  @Prop({ default: false, type: Boolean }) small!: boolean;

  formatDefinitions: ExportFormat[] = [
    {
      value: "excel",
      label: "Excel (.xlsx)",
      icon: "mdi-file-excel",
      color: "green darken-1",
    },
    {
      value: "csv",
      label: "CSV (.csv)",
      icon: "mdi-file-delimited",
      color: "blue darken-1",
    },
    {
      value: "json",
      label: "JSON (.json)",
      icon: "mdi-code-json",
      color: "amber darken-2",
    },
    {
      value: "pdf",
      label: "PDF (.pdf)",
      icon: "mdi-file-pdf-box",
      color: "red darken-1",
    },
  ];

  get availableFormats(): ExportFormat[] {
    return this.formatDefinitions.filter((f) => this.formats.includes(f.value));
  }

  exportData(format: string): void {
    if (!this.data || this.data.length === 0) {
      const MessageService =
        require("@/shared/services/message-service").MessageService;
      MessageService.toast("No hay datos para exportar", "warning");
      return;
    }

    try {
      switch (format) {
        case "excel":
          this.exportToExcel();
          break;
        case "csv":
          this.exportToCSV();
          break;
        case "json":
          this.exportToJSON();
          break;
        case "pdf":
          this.exportToPDF();
          break;
      }
      this.$emit("exported", { format, filename: this.filename });
    } catch (error) {
      console.error("Export error:", error);
      this.$emit("error", error);
    }
  }

  exportToExcel(): void {
    // Para Excel real se recomienda instalar 'xlsx'
    this.exportToCSV();
  }

  exportToCSV(): void {
    if (this.data.length === 0) return;

    const headers = Object.keys(this.data[0]);
    const csvContent = [
      headers.join(","),
      ...this.data.map((row) =>
        headers
          .map((header) => {
            const value = row[header];
            if (
              typeof value === "string" &&
              (value.includes(",") ||
                value.includes('"') ||
                value.includes("\n"))
            ) {
              return `"${value.replace(/"/g, '""')}"`;
            }
            return value === null || value === undefined ? "" : value;
          })
          .join(",")
      ),
    ].join("\n");

    this.downloadFile(
      "\ufeff" + csvContent, // BOM para Excel
      `${this.filename}.csv`,
      "text/csv;charset=utf-8;"
    );
  }

  exportToJSON(): void {
    const jsonContent = JSON.stringify(this.data, null, 2);
    this.downloadFile(jsonContent, `${this.filename}.json`, "application/json");
  }

  exportToPDF(): void {
    console.log("Exportando a PDF...", this.data);
  }

  downloadFile(content: string, filename: string, mimeType: string): void {
    const blob = new Blob([content], { type: mimeType });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = filename;
    link.click();
    URL.revokeObjectURL(link.href);
  }
}
